import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/property/green-area',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/property/green-area/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/property/green-area',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/property/green-area',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/property/green-area/${id}`);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    listAreaInfo: () => {
      return instance.get('/api/property/green-area/list');
    }

}
